import HTTP from "../../HTTP";
import Jsona from "jsona";

import paramsHelpers from "@/API/helpers/params";
import feedbackHelper from "@/API/helpers/feedbacks";
import accountableHelper from "@/API/helpers/accountables";
import pgaHelper from "@/API/helpers/paymentGatewayAccount";
import professionalHelper from "@/API/helpers/professionals";

const dataFormatter = new Jsona();

export default {
  async index(number_page, field_sort, text_search, filtersToApply = []) {
    try {
      const pagination = { number: `${number_page}`, size: "20" };

      let filters = filtersToApply;

      if (!isNaN(text_search) && text_search.length == 11) {
        filters = [
          ...filters,
          { name: "professional_cpf", value: text_search }
        ];
      } else {
        filters = [...filters, { name: "text_search", value: text_search }];
      }

      return await this.searchProfessional(
        ["profile"],
        filters,
        pagination,
        field_sort
      );
    } catch (e) {
      throw `Ocorreu um erro ao listar os profissionais com status ${status}`;
    }
  },

  async getById(id) {
    let include = [
      "account.profile",
      "account.schedule.events",
      "account.phones",
      "account.payment_gateway_account",
      "account.payment_gateway_account.wallet",
      "account.payment_gateway_account.bank_accounts",
      "account.events",
      "events",
      "account.documents"
    ].join(",");

    try {
      let res = await HTTP.normal.get(
        `/professionals/${id}?include=${include}`
      );

      return dataFormatter.deserialize(res.data);
    } catch (e) {
      throw "Ocorreu um erro ao buscar o profissional!";
    }
  },

  async getOrders(id) {
    try {
      let res = await HTTP.normal.get(
        `/professionals/${id}?include=orders.customer.account.profile,orders.address,orders.schedule_event`
      );

      let dataFormated = dataFormatter.deserialize(res.data);
      return dataFormated.orders;
    } catch (e) {
      throw "Ocorreu um erro ao buscar os pedidos do profissional!";
    }
  },

  async getFeedbacks(professional_id) {
    try {
      let feedbacks = await HTTP.normal.get(
        `/professionals/${professional_id}/feedbacks`
      );
      return dataFormatter.deserialize(feedbacks.data);
    } catch (e) {
      throw e;
    }
  },

  async addFeedback(payload) {
    try {
      let feedbacks = await HTTP.normal.post(
        `/feedbacks`,
        feedbackHelper.createRequestBody(payload)
      );
      return dataFormatter.deserialize(feedbacks.data);
    } catch (e) {
      throw e;
    }
  },

  async removeFeedback(feedback_id) {
    try {
      await HTTP.normal.delete(`/feedbacks/${feedback_id}`);
    } catch (e) {
      throw e;
    }
  },

  async create(payload) {
    try {
      if (payload.professional.mei === "") delete payload.professional.mei;
      // Define professional document
      let document = professionalHelper.buildDocument(payload.professional);
      // Creates the Professional and its account and profile
      let professional = await HTTP.normal.post(
        "/professionals",
        professionalHelper.createRequestBody(payload)
      );
      professional = dataFormatter.deserialize(professional.data);

      professional["phone"] = payload.phones[0];
      professional["address"] = payload.address;
      professional["document"] = {
        document_type: "CPF",
        document_number: professional.cpf
      };

      // Send email verification to account email
      await HTTP.normal.post(
        "/management/email-verification/send",
        accountableHelper.emailVerificationRequestBody(professional)
      );
      // Verify account
      await HTTP.normal.post(
        "/management/email-verification/verify",
        accountableHelper.emailVerificationRequestBody(professional)
      );
      // Creates the Payment Gateway Account for the professional
      await HTTP.normal.post(
        "/payment-gateway-accounts",
        pgaHelper.createPGARequestBody(professional)
      );
      // Creates the Payment Gateway Account in the Gateway
      await HTTP.withAccept.post(
        "/payment-gateway-accounts/create-on-gateway",
        pgaHelper.createOnGatewayRequestBody(professional.account.id)
      );
    } catch (error) {
      throw error.response.data;
    }
  },

  async getAvailables(data) {
    try {
      let res = await HTTP.normal.post(
        "/professionals/available?page%5Blimit%5D=30",
        data
      );
      let professionals = dataFormatter.deserialize(res.data);

      if (professionals.length) {
        let schedule_events = res.data.included.filter(
          el => el.type === "schedule_events"
        );

        professionals.forEach(professional => {
          professional.schedule_event = schedule_events[0];
          schedule_events.splice(0, 1);
        });

        professionals = professionals.filter(
          professional => professional.schedule_event
        );
      }

      return professionals;
    } catch (e) {
      throw "Erro ao listar os profissionais disponíveis";
    }
  },

  async getDistricts(id) {
    try {
      let res = await HTTP.normal.get(
        `/professionals/${id}?include=districts.city,districts.rating,districts.pricing`
      );
      return dataFormatter.deserialize(res.data).districts;
    } catch (e) {
      throw "Erro ao listar os distritos do profissional";
    }
  },

  async searchProfessional(
    includes = [],
    filters = [],
    pagination = null,
    sort = null
  ) {
    const defaultIncludes = ["accountable"];
    includes = [...includes, ...defaultIncludes];

    filters = [
      ...filters,
      {
        name: "accountable_type",
        value: "Professional"
      }
    ];

    let params = paramsHelpers.buildParams({
      includes,
      filters,
      pagination,
      sort
    });

    let url = `accounts${params}`;

    try {
      let res = await HTTP.normal.get(url);
      return {
        data: dataFormatter.deserialize(res.data),
        meta: res.data.meta
      };
    } catch (error) {
      throw error;
    }
  },

  async searchByCPF(cpf, includes = [], filters = [], pagination = {}) {
    filters = [...filters, { name: "cpf", value: cpf }];

    let params = paramsHelpers.buildParams({ includes, filters, pagination });

    let url = `professionals${params}`;

    try {
      let res = await HTTP.normal.get(url);
      return {
        data: dataFormatter.deserialize(res.data),
        meta: res.data.meta
      };
    } catch (error) {
      throw error;
    }
  },

  async searchByDistrictAndName(payload) {
    try {
      let query = payload.query.replace(/ /g, ",");
      let res = await HTTP.normal.get(
        `/queries/professionals/available-on-district-by-name?professional_name=${query}&district_id=${payload.district_id}`
      );
      return dataFormatter.deserialize(res.data);
    } catch (e) {
      throw "Ocorreu um erro ao buscar os profissionais por distrito e por nome!";
    }
  },

  async updateProfessional(professional) {
    try {
      let data = {
        data: {
          type: "professionals",
          id: professional.id,
          attributes: {
            mei: professional.mei,
            rating: professional.rating
          }
        }
      };

      return await HTTP.normal.patch(`/professionals/${professional.id}`, data);
    } catch (e) {
      throw "Ocorreu um erro ao atualizar os dados do profissional!";
    }
  },

  async updateRating(professional) {
    try {
      let data = {
        data: {
          type: "professionals",
          id: professional.id,
          attributes: {
            rating: professional.rating
          }
        }
      };

      await HTTP.normal.patch(`/professionals/${professional.id}`, data);
    } catch (e) {
      throw "Ocorreu um erro ao atualizar a nota do profissional!";
    }
  },

  async updateAccount(account) {
    try {
      let data = {
        data: {
          type: "accounts",
          id: account.id,
          attributes: {
            first_name: account.first_name,
            last_name: account.last_name
          }
        }
      };

      return await HTTP.normal.patch(`/accounts/${account.id}`, data);
    } catch (e) {
      throw "Ocorreu um erro ao atualizar a conta do profissional!";
    }
  },

  async createPhone(phone, account_id) {
    try {
      let data = {
        data: {
          type: "phones",
          attributes: phone,
          relationships: {
            owner: {
              data: {
                type: "account",
                id: account_id
              }
            }
          }
        }
      };

      return await HTTP.normal.post(`/phones`, data);
    } catch (e) {
      throw "Ocorreu um erro ao criar o telefone do profissional!";
    }
  },

  async updatePhone(phone) {
    try {
      let data = {
        data: {
          type: "phones",
          id: phone.id,
          attributes: {
            area_code: phone.area_code,
            number: phone.number,
            country_code: phone.country_code
          }
        }
      };

      return await HTTP.normal.patch(`/phones/${phone.id}`, data);
    } catch (e) {
      throw "Ocorreu um erro ao atualizar o telefone do profissional!";
    }
  },

  async updateProfile(profile) {
    try {
      let data = {
        data: {
          type: "profiles",
          id: profile.id,
          attributes: {
            profile_picture: profile.profile_picture,
            city_name: profile.city_name,
            state_name: profile.state_name,
            birthdate: profile.birthdate
          }
        }
      };

      return await HTTP.normal.patch(`/profiles/${profile.id}`, data);
    } catch (e) {
      throw "Ocorreu um erro ao atualizar o perfil do profissional!";
    }
  },

  async addDistricts(payload) {
    try {
      let data = {
        data: {
          type: "professionals",
          id: payload.professional_id,
          relationships: {
            districts: {
              data: []
            }
          }
        }
      };

      payload.districts.forEach(district => {
        data.data.relationships.districts.data.push({
          type: "districts",
          id: district.id
        });
      });

      return await HTTP.normal.patch(
        `/professionals/${payload.professional_id}`,
        data
      );
    } catch (e) {
      throw "Erro ao relacionar distritos ao profissional";
    }
  },

  async deactivate(account_id, description, operation) {
    let data = {
      description: `${operation.toUpperCase()} | ${description}`
    };

    try {
      return await HTTP.normal.post(
        `/management/accounts/${account_id}/deactivate`,
        data
      );
    } catch (e) {
      throw e;
    }
  },

  async activate(account_id, description) {
    let data = {
      description: `ATIVACAO | ${description}`
    };
    try {
      return await HTTP.normal.post(
        `/management/accounts/${account_id}/activate`,
        data
      );
    } catch (e) {
      throw e;
    }
  },

  async createPGAOnGateway(account_id) {
    try {
      return await HTTP.withAccept.post(
        "/payment-gateway-accounts/create-on-gateway",
        pgaHelper.createOnGatewayRequestBody(account_id)
      );
    } catch (e) {
      throw e;
    }
  },

  async block(account_id, description, operation) {
    let data = {
      description: `${operation.toUpperCase()} | ${description}`
    };

    try {
      return await HTTP.normal.post(
        `/management/accounts/${account_id}/block`,
        data
      );
    } catch (e) {
      throw e;
    }
  },

  async unblock(account_id, description, operation) {
    let data = {
      description: `${operation.toUpperCase()} | ${description}`
    };

    try {
      return await HTTP.normal.post(
        `/management/accounts/${account_id}/unblock`,
        data
      );
    } catch (e) {
      throw e;
    }
  },

  async successBackgroundCheck(professional_id) {
    try {
      return await HTTP.normal.post(
        `/management/professionals/${professional_id}/success_to_background_check`
      );
    } catch (e) {
      throw e;
    }
  },

  async succesValidateDocuments(professional_id) {
    try {
      return await HTTP.normal.post(
        `/management/professionals/${professional_id}/success_to_validate_documents`
      );
    } catch (e) {
      throw e;
    }
  },

  async askForDocuments(professional_id) {
    try {
      return await HTTP.normal.post(
        `/management/professionals/${professional_id}/ask_for_documents`
      );
    } catch (e) {
      throw e;
    }
  },

  async requestDocumentsValidation(professional_id) {
    try {
      return await HTTP.normal.post(
        `/management/professionals/${professional_id}/request_documents_validation`
      );
    } catch (e) {
      throw e;
    }
  },

  async requestBackgroundCheck(professional_id) {
    try {
      return await HTTP.normal.post(
        `/management/professionals/${professional_id}/check_background`
      );
    } catch (e) {
      throw e;
    }
  },

  async denyAccess(professional_id) {
    try {
      return await HTTP.normal.post(
        `/management/professionals/${professional_id}/deny_access`
      );
    } catch (e) {
      throw e;
    }
  },

  async startTraining(professional_id) {
    try {
      return await HTTP.normal.post(
        `/management/professionals/${professional_id}/start_training`
      );
    } catch (e) {
      throw e;
    }
  },

  async approveOnTraining(professional_id) {
    try {
      return await HTTP.normal.post(
        `/management/professionals/${professional_id}/approve_on_training`
      );
    } catch (e) {
      throw e;
    }
  },

  async reproveOnTraining(professional_id) {
    try {
      return await HTTP.normal.post(
        `/management/professionals/${professional_id}/reprove_on_training`
      );
    } catch (e) {
      throw e;
    }
  }
};



// WEBPACK FOOTER //
// ./src/API/modules/professionals/professionals.js